module.exports = __webpack_public_path__ + "img/5.1.b2d92326.jpg";